import { connect } from 'react-redux';
import PlanningBoardBottom from '../components/planning-board-bottom';
import {
  updateFilters,
  updateView,
  clearWorklistData,
} from './../../worklist/containers/worklist-actions';

const mapStateToProps = state => ({
  filterDefinitions: state.worklist.filterDefinitions,
  isDataLoading: state.worklist.isDataLoading,
  activeFilters: state.worklist.activeFilters,
  menuVisible: state.header.menuVisible,
  fullScreen: state.planningBoard.fullScreen,
  views: state.worklist.views,
  addedBlockIds: state.gantt.addedBlockIds,
  filterGroups: state.worklist.filterGroups,
  error: state.worklist.fetchError,
});

const mapDispatchToProps = {
  updateFilters,
  updateView,
  clearWorklistData,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanningBoardBottom);
